import Big from 'big.js'
import useIntl from '../useIntl/useIntl'

const hasDecimals = (number: number) => number % 1 !== 0

export const usePricingMessageFormatters = () => {
  const intl = useIntl()
  return {
    formatAvios: (value: number) => intl.formatNumber(value),
    addAviosLabel: (avios: string) =>
      intl.formatMessage(
        {
          id: 'avios-with-label',
          defaultMessage: '{avios} Avios',
        },
        { avios }
      ),
    formatCash: (cash: Big | number, currency: string) => {
      const n = cash instanceof Big ? cash.round(2, Big.roundUp).toNumber() : cash
      return intl.formatNumber(n, {
        style: 'currency',
        currency,
        currencyDisplay: 'symbol',
        minimumFractionDigits: hasDecimals(n) ? 2 : 0,
      })
    },
    formatAndRoundCash: (cash: Big | number, currency: string) => {
      const n = cash instanceof Big ? cash.round(2, Big.roundUp).toNumber() : cash

      return intl.formatNumber(n, {
        style: 'currency',
        currency,
        currencyDisplay: 'symbol',
        maximumFractionDigits: 0,
      })
    },
    formatAgeGroupCount: (ageGroup: string, count: number) => {
      return intl.formatMessage(
        {
          id: 'format-age-group-count',
          defaultMessage: '{count} x {ageGroup}',
        },
        { ageGroup, count }
      )
    },
  }
}
